import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { CategoriaApi } from '../models/api/categoria-api';
import { ResponseApi } from '../models/response-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class CategoriaService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/categoria/';
    private cache$?: Observable<CategoriaApi[]>;

    listCategorias(): Observable<CategoriaApi[]> {
        if (!this.cache$) {
            this.cache$ = this.http.get<ResponseApi<CategoriaApi[]>>(this.url + 'list-categorias').pipe(
                map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : [])),
                shareReplay(1)
            );
        }
        return this.cache$;
    }

    invalidate(): void {
        this.cache$ = undefined;
    }

    createCategoria(body: {
        padreUuid?: string | null;
        nombre: string;
        slug?: string;
        descripcion?: string;
        imagenUuid?: string | null;
        mostrarEnMenu: boolean;
        orden: number;
    }): Observable<boolean> {
        return this.http.post<ResponseApi<unknown>>(this.url + 'create-categoria', body).pipe(
            tap(() => this.invalidate()),
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }

    updateCategoria(uuid: string, body: {
        padreUuid?: string | null;
        nombre: string;
        slug?: string;
        descripcion?: string;
        imagenUuid?: string | null;
        mostrarEnMenu: boolean;
        orden: number;
    }): Observable<boolean> {
        return this.http.put<ResponseApi<unknown>>(this.url + 'update-categoria/' + uuid, body).pipe(
            tap(() => this.invalidate()),
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }

    deleteCategoria(uuid: string): Observable<boolean> {
        return this.http.delete<ResponseApi<unknown>>(this.url + 'delete-categoria/' + uuid).pipe(
            tap(() => this.invalidate()),
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }
}
